// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "lead_membership".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { leadMembershipStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "lead_membership" table (1:1 with a DB row, on the wire). */
export const leadMembershipAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    leadId: z.string(),
    planId: z.string(),
    sessionsRemaining: z.number().nullable(),
    validUntil: z.string().datetime().nullable(),
    stripeSubscriptionId: z.string().nullable(),
    status: z.enum(leadMembershipStatusValues),
    saleItemId: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=leadMembership.js.map